import { render } from "./stockCheck.vue?vue&type=template&id=4277c0eb"
import script from "./stockCheck.vue?vue&type=script&lang=js"
export * from "./stockCheck.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__